import React, { useState } from "react";
import { Col,  Form,  Modal, Row, InputNumber } from "antd";
import { PRIMARY_COLOR, SUCCESS_COLOR } from "../../constants/color";
import { POST } from "../../frameworks/HttpClient";
import { URL_POND, URL_TANK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import _ from "lodash";
import { TANK_ACTION } from "../../constants/string";

export default function StorageTankCloseModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const weightWatch = Form.useWatch('weight', form)
  
  const handleOK = async() => {
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      data['action'] = TANK_ACTION.CLOSE
      await POST(`${URL_TANK.TANK_TRANSACTION}${target.current_transaction}/change-state/`, data)
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      form.resetFields();
    }
  },[open])

  return(
    <Modal
      open={open}
      onCancel={onClose}
      title={`ปิดแทงก์ ${_.get(target, 'name', '-')} - [${_.get(target, 'lot_no', '-')}]`}
      width={500}
      okText={"ยืนยัน"}
      cancelText={"ยกเลิก"}
      okButtonProps={{ style: { backgroundColor : PRIMARY_COLOR}}}
      onOk={handleOK}
    >
      <ErrorMessages message={errorMessages}/>
      <Form 
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={12}>
            <Form.Item 
              name={'weight'}
              label={'น้ำหนัก (Kg)'}
              rules={[{ required: true, message: 'กรุณากรอกน้ำหนัก!' }]}
            >
              <InputNumber placeholder="น้ำหนัก" style={{ width : '95%' }} precision={0}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              name={'height'}
              label={'ความสูง (Cm)'}
              rules={[{ required: true, message: 'กรุณากรอกความสูง!' }]}
            >
              <InputNumber 
                autoComplete="off" 
                style={{ width : '95%', marginLeft : 5 }} 
                placeholder="ส่วนสูง" 
                onChange={(value) => {
                  if(target.weight_per_height){
                    form.setFieldValue('weight', Math.round(value * target.weight_per_height))
                  }
                }}
                onPressEnter={(e) => !weightWatch ? form.setFieldValue('weight', (e.target.value * target.weight_per_height)) : handleOK()} 
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}